const dev = {
  url: {
    API_BASE: "http://localhost:1337",
    DASH_BASE: "http://localhost:3000"
  },
  RECAPTCHA_KEY: "6LdhcP0jAAAAAIXMMIoWAmZlR-0hhyDAXFjMnmIF",
  STRIPE_PUBLISHABLE_KEY: "pk_test_51IDVMPCZklr2woZF8O2Isu1807WiJBMykHn9QDnQ5MhImBIwrNHVugN4EZO3OdwyhV2t8SNPjpuq4DrPt4vrmm0L008XQ0v2Cm"
};

const prod = {
  url: {
    API_BASE: "https://api2.yoghurtbot.net",
    DASH_BASE: "https://dashboard.yoghurtbot.net"
  },
  RECAPTCHA_KEY: "6LdhcP0jAAAAAIXMMIoWAmZlR-0hhyDAXFjMnmIF",
  STRIPE_PUBLISHABLE_KEY: "pk_live_51IDVMPCZklr2woZF1PZbc5wY8RFzrAfgzaSDN1TdUNsO3Etab8yyz9sVPWcgDYaR2NYfldAqVEF8Aa5nP0sHhtCA00UCUxiz7L"
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;
